<template>
    <ul class="member_list" >
        <li class="member_item" style="background:#FFFFFF;padding-bottom:20px" v-for="(item,index) in list"  :key='index' @click="button(item)">
            <div class="img_box" >
                <img class="item_img" :src="item.url" alt="">
            </div>
            <div class="item_content" style="background:#FFFFFF">
                <h3 style="color:#2A303C;font-weight: bold;text-align:left;padding-left:10px;font-size:20px">{{item.titleCh}}</h3>
                <h3 style="color:#77818E;font-weight:400;text-align:left;padding-left:10px;font-size:16px;padding-top:10px">{{item.titleEn}}</h3>
                <h3 class="left" style="padding-left:10px;padding-top:16px">
                    <div class="flexStart" style="font-size:16px">
                        <img src="../assets/img/dingwei.png" alt />
                        {{item.location}}
                    </div>
                    <div class="check_more" v-if="item.id==10||item.id==53" @click="goMemeber">
                        <div v-if="chOrEn!='0'">了解更多</div>
                        <div v-else>more</div>
                    </div>
                    <!-- <div class="check_more" v-if="item.id==10||item.id==53" @click="goMemeber">more</div> -->
                </h3>
                <!-- <h4>{{item.county}}</h4> -->
            </div>
        </li>
    </ul>
</template>

<script>
    export default {
        name:'memberlist',
        data() {
            return {
                chOrEn:sessionStorage.getItem('chOrEn'),
            }
        },
        props:{
            list:{
                type:Array,
                value:[]
            }
        },
        methods:{
            goMemeber(){

            },
            button(i){
                if(i.id==10||i.id==53){
                    window.open('http://www.ccwsp.com')
                }
            },
        },
        mounted() {
        }
    }
</script>

<style lang="less" scoped>
.check_more {
    width: 128px;
    background: #24367D;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 32px;
    height: 32px;
    // border-radius: 5px;
    // margin:30px auto;
    margin-right:10px
    // cursor: pointer;
}
.flexStart{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.left{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.member_list{
    margin-top: 34px;
    display: flex;
    height:400px;
    .member_item{
        flex:1;
        border:1px solid #e5e5e5;
        border-radius: 10px;
        margin:0 10px;
        cursor: pointer;
        transition: all 1s ease;
        .img_box{
            width: 100%;
            height: 250px;
            overflow: hidden;
            img{
                width: 100%;
                height: 100%;
                transition: all 1s ease;
            }
            img:hover{
                transform: scale(1.2);
            }
        }
        .item_content{
            padding-top: 20px;
            text-align: center;
            color: #262626;
            font-size: 16px; 
            h3{
                line-height: 30px;
            }
            h4{
                line-height: 56px;
            }
        }
    }
    .member_item:hover{
        transform: translateY(-20px);
        -moz-box-shadow:8px 8px 6px #efefef; 
        -webkit-box-shadow:8px 8px 6px #efefef;
        box-shadow:8px 8px 6px #efefef;
    }
}
</style>